// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-big[data-v-5e1a8b6c] {\n  margin-right: 1.5rem;\n  margin-left: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
